import { EBAY, ETSY, SHOPIFY } from '../../constants/channels';
import { OPERATIONS } from '../../constants/product';

export function getVideoOperation({ channel, products, video }) {
  switch (channel) {
    case EBAY: {
      return {
        products,
        type: OPERATIONS[EBAY].VIDEOS.CHANGE_TO,
        value: [video],
      };
    }

    case ETSY: {
      return {
        products,
        type: OPERATIONS[ETSY].VIDEOS.CHANGE_TO,
        value: [video],
      };
    }

    case SHOPIFY: {
      return {
        products,
        type: OPERATIONS[SHOPIFY].VIDEOS.ADD,
        value: [video],
      };
    }

    default: {
      return undefined;
    }
  }
}
